<div class="recollect-modal__backdrop animated fadeIn">
  <div class="recollect-modal__wrapper">
    <div class="recollect-modal">
      <div class="recollect-modal__header">
        <h3 class="drecollect-modal__title">{{data?.title}}</h3>
      </div>
      <div class="recollect-modal__content">
        <p>You are about to recollect dashboard for the following organization:</p>
        <div class="recollect-modal__info">
          <p><b>Organization Name:</b> {{data?.options['org_name']}}</p>
					<p><b>Organization ID:</b> {{data?.options['org_id']}}</p>
					<div class="recollect-modal__form-field-wrapper">
						<b>AWS Services:</b>
						<mat-form-field appearance="outline" >
							<mat-label>Available Services</mat-label>
							<mat-select [formControl]="aws_services" multiple>
								<mat-select-trigger>
									{{aws_services.value ? aws_services.value[0] : ''}}
									<span *ngIf="aws_services.value?.length > 1">
										(+{{aws_services.value.length - 1}} {{aws_services.value?.length === 2 ? 'other' : 'others'}})
									</span>
								</mat-select-trigger>
								<mat-option *ngFor="let service of awsServicesList" [value]="service">{{service}}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>

        </div>
      </div>
      <div class="recollect-modal__actions">
        <button class="recollect-modal__close" (click)="closeEvent()">Close</button>
        <button class="recollect-modal__create" (click)="confirm()">Apply </button>
      </div>
      <ng-container *ngIf="showConfirm">
        <app-show-confirm (confirmed)="onConfirmed($event)"></app-show-confirm>
      </ng-container>
      <ng-container *ngIf="initProcess">
        <app-show-process [process]="processStatus | async"></app-show-process>
      </ng-container>
    </div>
  </div>
</div>
